import React from "react";
import { Box, Typography, IconButton, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { styled } from "@mui/material/styles";

const CardContainer = styled(Box)(({ theme, clickable }) => ({
  backgroundColor: "#ffffff",
  borderRadius: "6px",
  padding: "20px",
  height: "fit-content",
  display: "flex",
  flexDirection: "column",
  ...(clickable && {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#ede3f5",
      border: `3px solid ${theme.palette.primary.main}`,
      padding: "17px",
    },
  }),
}));

const CardHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "16px",
});

const CardTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Montserrat, sans-serif",
  fontWeight: 600,
  letterSpacing: "0.14px",
  color: "#333333",
  textTransform: "capitalize",
}));

const ArrowButton = styled(IconButton)(({ theme }) => ({
  color: "#333333",
  width: "31px",
  height: "31px",
  padding: "4px",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
  },
}));

const TextActionButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: "13px",
  fontWeight: 600,
  textTransform: "none",
  padding: "4px 8px",
  minWidth: "auto",
  "&:hover": {
    backgroundColor: "rgba(102, 45, 145, 0.08)",
  },
}));

const TextWithIconButton = styled(Button)(({ theme }) => ({
  fontFamily: "Montserrat, sans-serif",
  fontWeight: 600,
  fontSize: "14.93px",
  lineHeight: "157%",
  letterSpacing: "0px",
  color: "#333333",
  textTransform: "none",
  padding: "4px 8px",
  minWidth: "auto",
  display: "flex",
  alignItems: "center",
  gap: "4px",
  "&:hover": {
    backgroundColor: "rgba(102, 45, 145, 0.08)",
  },
}));

const DashboardCard = ({
  title,
  children,
  action,
  onArrowClick,
  showArrow = true,
  sx = {},
  onClick,
}) => {
  const renderAction = () => {

    if (action?.onClick) {
      if (action.type === 'text') {
        return (
          <TextActionButton onClick={action.onClick} size="small">
            {action.label}
          </TextActionButton>
        );
      }
      if (action.type === 'text-with-icon') {
        return (
          <TextWithIconButton onClick={action.onClick} size="small">
            {action.label}
            <ArrowForwardIcon fontSize="small" />
          </TextWithIconButton>
        );
      }

      return (
        <ArrowButton onClick={action.onClick} size="small">
          <ArrowForwardIcon fontSize="small" />
        </ArrowButton>
      );
    }

    if (showArrow && onArrowClick) {
      return (
        <ArrowButton onClick={onArrowClick} size="small">
          <ArrowForwardIcon fontSize="small" />
        </ArrowButton>
      );
    }

    return null;
  };

  return (
    <CardContainer sx={sx} onClick={onClick} clickable={onClick ? 1 : 0}>
      <CardHeader>
        <CardTitle
          component="div"
          sx={{
            fontSize: { xs: "12px", sm: "16px" },
            lineHeight: { xs: "13px", sm: "16px" },
          }}>{title}</CardTitle>
        {renderAction()}
      </CardHeader>
      <Box sx={{ flex: 1 }}>{children}</Box>
    </CardContainer>
  );
};

export default DashboardCard;
